import { csv } from 'd3-fetch';
import WKT from 'ol/format/WKT';
import { userData as types } from '../mutation-types';

export default {
    namespaced: true,
    state: {
        currentPosition: [0, 0],
        spotPosition: [0, 0], // zoom in 景點
        validScopExtent: '',
        positionErrorCode: null,
    },
    getters: {
        isInValidScope: (state) => {
            if (
                !state.validScopExtent
                || state.currentPosition[0] === 0
                || state.currentPosition[1] === 0
            ) {
                return false;
            }
            const format = new WKT();

            const feature = format.readFeature(state.validScopExtent, {
                dataProjection: 'EPSG:3826',
                featureProjection: 'EPSG:4326',
            });
            return feature
                .getGeometry()
                .intersectsCoordinate(state.currentPosition);
        },
        showDistance: (state, getters) => state.currentPosition[0] !== 0
            && state.currentPosition[0] !== 0
            && getters.isInValidScope,
        positionErrorText: (state) => {
            const [lon, lat] = state.currentPosition;
            if (lon !== 0 && lat !== 0) {
                return '';
            }
            let text = '';
            switch (state.positionErrorCode) {
                case 1:
                    text = '無法取得定位!!請同意瀏覽器取得定位';
                    break;
                case 2:
                    text = '無法取得定位!!請確認手機定位功能已開啟';
                    break;
                case 3:
                    text = '無法取得定位!!已逾時';
                    break;
                default:
                    break;
            }
            return text;
        },
    },
    actions: {
        setCurrentPosition({ commit }, val) {
            commit(types.setCurrentPosition, val);
        },
        setPositionErrorCode({ commit }, val) {
            commit(types.setPositionErrorCode, val);
        },
        setSpotPosition({ commit }, val) {
            commit(types.setSpotPosition, val);
        },
        async setValidScopExtent({ commit }) {
            const val = await csv('./static/TOWN_Taichung.csv').then(
                (res) => res[0].WKT,
            );
            commit(types.setValidScopExtent, val);
        },
    },
    mutations: {
        [types.setCurrentPosition]: (state, data) => {
            state.currentPosition = data;
        },
        [types.setPositionErrorCode]: (state, data) => {
            state.positionErrorCode = data;
        },
        [types.setSpotPosition]: (state, data) => {
            state.spotPosition = data;
        },
        [types.setValidScopExtent]: (state, data) => {
            state.validScopExtent = data;
        },
    },
};
